import { Stats } from '@/components/dashboard/stats'
import { Table as TestExecutionTable } from '@/components/test_executions/table'
import { Table as TestResultSyncTable } from '@/components/test_execution_syncs/table'

export const Index = () => {
  return (
  <div className='flex flex-col gap-6'>
    <div>
      <Stats />
    </div>
    <div className='grid grid-cols-2 gap-6'>
      <TestExecutionTable />
      <TestResultSyncTable />
    </div>
  </div>
  )
}
